<template>
  <form @submit.prevent="start">
    <h2>참여자 확인</h2>
    <p>{{ instructions }}</p>
    <p class="notice">연구자가 안내한 참여자 ID를 입력해주세요. 이름이나 연락처는 입력하지 마세요.</p>
    <label for="participant-id">참여자 ID</label>
    <input id="participant-id" v-model="participantId" :disabled="busy" required maxlength="80" autocomplete="off" placeholder="예: P001" />
    <p class="notice">같은 브라우저에서 같은 ID를 입력하면 마지막 저장 지점부터 이어집니다. 다른 기기에서의 이어하기는 아직 지원하지 않습니다.</p>
    <button type="submit" :disabled="busy || !participantId.trim()">{{ busy ? '참여 기록 확인 중…' : '시작 또는 이어하기' }}</button>
  </form>
</template>
<script>
export default {
  props: { instructions: { type: String, required: true }, busy: Boolean },
  emits: ['start'],
  data: () => ({ participantId: '' }),
  methods: { start() { if (this.participantId.trim()) this.$emit('start', this.participantId.trim()); } }
};
</script>
